"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _ActiveAddonsContainer = _interopRequireDefault(require("./ActiveAddons/ActiveAddonsContainer"));
var _EligibleAddonsContainer = _interopRequireDefault(require("./EligibleAddons/EligibleAddonsContainer"));
var _reactRedux = require("react-redux");
var _selector = require("../selectors/selector");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _queryString = _interopRequireDefault(require("query-string"));
var _Actions = require("../actions/Actions");
var _useProps2 = _interopRequireDefault(require("../hooks/useProps"));
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
require("../utils/strings");
var _Popup = _interopRequireDefault(require("./Cancellation/Popup"));
var _appConstants = require("../appConstants");
var _updateModeParam = _interopRequireDefault(require("../utils/updateModeParam"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// import Filters from './Filters';

// function haveAllAddonTypes(addons, filters) {
//   const excludeAllOption = filters.filter(option => option.key !== 'all');

//   return excludeAllOption.some(option => addons.find(addon => addon.type === option.key));
// }
function App(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouterDom.useHistory)();
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    search = _useLocation.search;
  var _useProps = (0, _useProps2.default)(),
    addonIcons = _useProps.addonIcons,
    defaultAddonIcon = _useProps.defaultAddonIcon;
  var config = (0, _useConfig.default)();
  var defaultMode = config.defaultMode;
  // const addons = useSelector(getAddons);
  var currentMode = (0, _reactRedux.useSelector)(_selector.getCurrentMode);
  var params = _queryString.default.parse(search);
  var modeParam = params['mode'];

  // const [filteredAddons, setFilteredAddons] = useState(addons);
  // const isNoActiveAddons = addons?.length === 0;
  // const isFilterShouldVisible = props.visibility.filters < addons?.length;
  // const isShowFilter =
  //   !isNoActiveAddons && isFilterShouldVisible && haveAllAddonTypes(addons, props.filters);

  (0, _react.useEffect)(function () {
    dispatch((0, _Actions.setAddonIcons)(addonIcons));
    dispatch((0, _Actions.setDefaultAddonIcon)(defaultAddonIcon));
    dispatch((0, _Actions.setStaticAddons)(props.isStaticAddons));
  }, []);

  // useEffect(() => {
  //   setFilteredAddons(addons);
  // }, [addons]);

  (0, _react.useEffect)(function () {
    var pathname = history.location.pathname;
    return function () {
      if (window.location.pathname === pathname) return;
      var params = _queryString.default.exclude(window.location.search, ['mode']);
      history.replace({
        search: params
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (modeParam == currentMode && !!currentMode) return;
    var updatedMode;
    switch (Object.values(_appConstants.MODES).find(function (m) {
      return m === (modeParam === null || modeParam === void 0 ? void 0 : modeParam.toLowerCase());
    }) || defaultMode) {
      case _appConstants.MODES.sellable:
        updatedMode = _appConstants.MODES.sellable;
        break;
      case _appConstants.MODES.active:
        updatedMode = _appConstants.MODES.active;
        break;
      default:
        break;
    }
    if (updatedMode) {
      dispatch((0, _Actions.setCurrentMode)(updatedMode));
      (0, _updateModeParam.default)(history, updatedMode);
    }
  }, [currentMode, modeParam]);
  if (!Object.keys(config || {}).length) return null;
  switch (currentMode) {
    case _appConstants.MODES.sellable:
      return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Grid, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          top: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_EligibleAddonsContainer.default, null)));
    case _appConstants.MODES.active:
      return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Grid, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          top: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_Popup.default, {
        cancelApi: props.cancelApi
      }), /*#__PURE__*/_react.default.createElement(_ActiveAddonsContainer.default, null)));
    default:
      return null;
  }
}
App.propTypes = {
  filters: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    icon: _propTypes.default.string.isRequired
  })).isRequired,
  visibility: _propTypes.default.shape({
    filters: _propTypes.default.number.isRequired,
    cancelButton: _propTypes.default.bool.isRequired,
    renewButton: _propTypes.default.bool.isRequired
  }).isRequired,
  cancelApi: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    endPoint: _propTypes.default.string.isRequired
  }).isRequired,
  isStaticAddons: _propTypes.default.bool.isRequired
};